import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="about" className="section-padding">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-header">
            <h2 className="section-title">About Me</h2>
            <div className="section-divider"></div>
          </div>

          <div className="about-content">
            <motion.div
              className="about-text"
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <p className="about-paragraph justify">
                I'm a <strong>Full Stack Developer</strong> and <strong>Microsoft Most Valuable Professional (MVP)</strong>, 
                passionate about building scalable, high-impact digital solutions.
              </p>
              
              <p className="about-paragraph justify">
                I specialize in modern web and mobile app development and currently serve as the 
                <strong> Training & Placement Coordinator</strong> at Birla Vishwakarma Mahavidyalaya, 
                where I help bridge academia and industry while mentoring students.
              </p>
              
              <p className="about-paragraph justify">
                With hands-on experience across companies like <strong>AMUL</strong>, <strong>NDDB</strong>, 
                and multiple startups, I focus on developing real-world systems, enterprise tools, 
                SaaS platforms, and production-ready applications.
              </p>

              <motion.div
                className="about-stats"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <motion.div 
                  className="stat-item"
                  whileHover={{ 
                    scale: 1.1, 
                    y: -10,
                    transition: { type: "spring", stiffness: 300, damping: 15 }
                  }}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }}
                  transition={{ delay: 0.5, type: "spring", stiffness: 100 }}
                >
                  <motion.h3 
                    className="stat-number"
                    initial={{ scale: 0 }}
                    animate={isInView ? { scale: 1 } : { scale: 0 }}
                    transition={{ delay: 0.6, type: "spring", stiffness: 200 }}
                  >
                    8+
                  </motion.h3>
                  <p className="stat-label">Projects</p>
                </motion.div>
                <motion.div 
                  className="stat-item"
                  whileHover={{ 
                    scale: 1.1, 
                    y: -10,
                    transition: { type: "spring", stiffness: 300, damping: 15 }
                  }}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }}
                  transition={{ delay: 0.7, type: "spring", stiffness: 100 }}
                >
                  <motion.h3 
                    className="stat-number"
                    initial={{ scale: 0 }}
                    animate={isInView ? { scale: 1 } : { scale: 0 }}
                    transition={{ delay: 0.8, type: "spring", stiffness: 200 }}
                  >
                    7+
                  </motion.h3>
                  <p className="stat-label">Experiences</p>
                </motion.div>
                <motion.div 
                  className="stat-item"
                  whileHover={{ 
                    scale: 1.1, 
                    y: -10,
                    transition: { type: "spring", stiffness: 300, damping: 15 }
                  }}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }}
                  transition={{ delay: 0.9, type: "spring", stiffness: 100 }}
                >
                  <motion.h3 
                    className="stat-number"
                    initial={{ scale: 0 }}
                    animate={isInView ? { scale: 1 } : { scale: 0 }}
                    transition={{ delay: 1.0, type: "spring", stiffness: 200 }}
                  >
                    5+
                  </motion.h3>
                  <p className="stat-label">Leadership</p>
                </motion.div>
              </motion.div>
            </motion.div>

            <motion.div
              className="about-image"
              initial={{ opacity: 0, x: 50, rotate: -10 }}
              animate={isInView ? { opacity: 1, x: 0, rotate: 0 } : { opacity: 0, x: 50, rotate: -10 }}
              transition={{ duration: 0.8, delay: 0.3, type: "spring", stiffness: 80 }}
              whileHover={{
                scale: 1.05,
                rotate: 2,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                className="image-wrapper"
                whileHover={{
                  boxShadow: "0 20px 60px rgba(99, 102, 241, 0.4)",
                  transition: { duration: 0.3 }
                }}
              >
                <img 
                  src="/vrajupadhyay.jpg" 
                  alt="Vraj Upadhyay - Full Stack Developer" 
                  className="profile-image"
                />
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
